export default __webpack_public_path__ + "static/media/Code.eb55f9df.svg";